import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  Wrench, Bell, GraduationCap, Users, Award, 
  BookOpen, ArrowRight, Mail, CheckCircle,
  Monitor, Sparkles, KeyRound, X, Loader2,
  Calendar, Clock, ShoppingBag, Share2, Copy, ExternalLink
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import axios from 'axios';
import { toast } from 'sonner';
import SEO, { PageSEO } from '../components/SEO';

import { API } from '../config/api';

// Social Media Links Data
const socialLinks = [
  { name: 'Discord', href: 'https://discord.gg/QRv8hpn9gk', color: 'bg-[#5865F2]', icon: (
    <svg className="w-5 h-5" fill="white" viewBox="0 0 24 24">
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
    </svg>
  )},
  { name: 'YouTube', href: 'https://www.youtube.com/@squidemy', color: 'bg-[#FF0000]', icon: (
    <svg className="w-5 h-5" fill="white" viewBox="0 0 24 24">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  )},
  { name: 'X', href: 'https://x.com/squidemy', color: 'bg-black', icon: (
    <svg className="w-5 h-5" fill="white" viewBox="0 0 24 24">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  )},
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/squidemy', color: 'bg-[#0A66C2]', icon: (
    <svg className="w-5 h-5" fill="white" viewBox="0 0 24 24">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  )},
  { name: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61584548987568', color: 'bg-[#1877F2]', icon: (
    <svg className="w-5 h-5" fill="white" viewBox="0 0 24 24">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  )},
  { name: 'TikTok', href: 'https://www.tiktok.com/@squidemy', color: 'bg-black', icon: (
    <svg className="w-5 h-5" fill="white" viewBox="0 0 24 24">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
    </svg>
  )},
  { name: 'Instagram', href: 'https://www.instagram.com/squidemy', color: 'bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737]', icon: (
    <svg className="w-5 h-5" fill="white" viewBox="0 0 24 24">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
    </svg>
  )}
];

// Nav Social Links - With text labels, compact for header
const NavSocialLinks = () => (
  <div className="flex items-center gap-2">
    {socialLinks.map((social) => (
      <a
        key={social.name}
        href={social.href}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-1.5 px-3 py-1.5 ${social.color} rounded-lg hover:scale-105 transition-transform`}
        title={`Follow us on ${social.name}`}
      >
        {social.icon}
        <span className="font-medium text-white text-xs">{social.name}</span>
      </a>
    ))}
  </div>
);

// Mobile Social Links - Smaller version for mobile bar
const MobileSocialLinks = () => (
  <div className="flex items-center gap-2 overflow-x-auto pb-1">
    {socialLinks.map((social) => (
      <a
        key={social.name}
        href={social.href}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-1 px-2.5 py-1.5 ${social.color} rounded-lg hover:scale-105 transition-transform flex-shrink-0`}
        title={`Follow us on ${social.name}`}
      >
        {social.icon}
        <span className="font-medium text-white text-xs">{social.name}</span>
      </a>
    ))}
  </div>
);

// Full Social Links Component - For main content area
const SocialLinksFull = () => (
  <div className="flex flex-wrap justify-center gap-3">
    {socialLinks.map((social) => (
      <a
        key={social.name}
        href={social.href}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-2 px-4 py-2.5 ${social.color} rounded-xl hover:scale-105 transition-transform`}
      >
        {social.icon}
        <span className="font-semibold text-white text-sm">{social.name}</span>
      </a>
    ))}
  </div>
);

const MaintenancePage = ({ launchDate }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  
  // Sequence code dialog
  const [showSequenceDialog, setShowSequenceDialog] = useState(false);
  const [sequenceCode, setSequenceCode] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [codeError, setCodeError] = useState('');
  
  // Countdown state
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [hasLaunchDate, setHasLaunchDate] = useState(false);

  const pageUrl = 'https://squidemy.com';
  const shareText = "Check out SQUIDEMY - the ultimate IT training platform launching soon! 🚀 #ITTraining #Squidemy";

  // Share functions
  const handleShare = (platform) => {
    const encodedUrl = encodeURIComponent(pageUrl);
    const encodedText = encodeURIComponent(shareText);
    
    const shareUrls = {
      twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      whatsapp: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
      telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
    };
    
    if (shareUrls[platform]) {
      window.open(shareUrls[platform], '_blank', 'width=600,height=400');
    }
    setShowShareMenu(false);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(pageUrl);
    toast.success('Link copied to clipboard!');
    setShowShareMenu(false);
  };

  // Calculate countdown
  useEffect(() => {
    if (!launchDate) {
      setHasLaunchDate(false);
      return;
    }
    
    setHasLaunchDate(true);
    const targetDate = new Date(launchDate).getTime();
    
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      
      if (distance < 0) {
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      
      setCountdown({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    };
    
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    
    return () => clearInterval(interval);
  }, [launchDate]);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setIsSubscribing(true);
    try {
      await axios.post(`${API}/maintenance/notify-signup`, { email });
      setSubscribed(true);
      toast.success('You\'re on the list! We\'ll notify you when we launch.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Subscription failed. Please try again.');
    } finally {
      setIsSubscribing(false);
    }
  };

  const handleVerifySequenceCode = async (e) => {
    e.preventDefault();
    if (!sequenceCode.trim()) {
      setCodeError('Please enter a sequence code');
      return;
    }
    
    setIsVerifying(true);
    setCodeError('');
    
    try {
      const response = await axios.post(`${API}/maintenance/verify-sequence-code`, { 
        code: sequenceCode 
      });
      
      if (response.data.success) {
        // Store bypass token
        localStorage.setItem('maintenance_bypass', response.data.bypass_token);
        toast.success('Access granted! Redirecting to login...');
        setShowSequenceDialog(false);
        // Force full page reload to reset MaintenanceGuard state
        setTimeout(() => {
          window.location.href = '/login';
        }, 1000);
      } else {
        setCodeError(response.data.message || 'Invalid sequence code');
      }
    } catch (error) {
      setCodeError(error.response?.data?.message || 'Verification failed. Please try again.');
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white overflow-hidden">
      <SEO {...PageSEO.maintenance} url="https://squidemy.com" />
      
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-purple-500/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-orange-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-500/10 rounded-full blur-3xl" />
      </div>

      {/* Navigation Bar with Social Links */}
      <nav className="relative z-10 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <img 
                src="/squiddy_logo.png" 
                alt="Squidemy Logo" 
                className="w-14 h-14 object-contain"
              />
              <span className="text-2xl font-bold" style={{ fontFamily: "'AstroSpace', sans-serif" }}>
                SQUIDEMY
              </span>
            </div>
            
            {/* Social Icons in Nav - Hidden on mobile */}
            <div className="hidden lg:flex items-center gap-3">
              <NavSocialLinks />
              <div className="w-px h-8 bg-white/20" />
              <Button 
                variant="outline" 
                className="border-white/30 text-white hover:bg-white/10"
                onClick={() => setShowSequenceDialog(true)}
              >
                <KeyRound className="w-4 h-4 mr-2" />
                Admin Login
              </Button>
            </div>
            
            {/* Medium screens: Just Admin Login */}
            <div className="hidden md:flex lg:hidden">
              <Button 
                variant="outline" 
                className="border-white/30 text-white hover:bg-white/10"
                onClick={() => setShowSequenceDialog(true)}
              >
                <KeyRound className="w-4 h-4 mr-2" />
                Admin Login
              </Button>
            </div>
            
            {/* Mobile: Just Admin Login */}
            <div className="md:hidden">
              <Button 
                variant="outline" 
                size="sm"
                className="border-white/30 text-white hover:bg-white/10"
                onClick={() => setShowSequenceDialog(true)}
              >
                <KeyRound className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile & Tablet Social Bar */}
      <div className="lg:hidden relative z-10 border-b border-white/10 py-3 px-4">
        <div className="flex justify-center">
          <MobileSocialLinks />
        </div>
      </div>

      {/* Hero Section */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="text-center mb-12">
          {/* Maintenance Icon */}
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="w-32 h-32 bg-gradient-to-br from-orange-500 to-purple-600 rounded-full flex items-center justify-center shadow-2xl shadow-purple-500/30">
                <Wrench className="w-16 h-16 text-white animate-bounce" style={{ animationDuration: '2s' }} />
              </div>
              <div className="absolute -top-2 -right-2 w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center animate-pulse">
                <Sparkles className="w-6 h-6 text-yellow-800" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            We're Building Something
            <span className="bg-gradient-to-r from-orange-400 to-purple-400 bg-clip-text text-transparent"> Amazing!</span>
          </h1>
          
          <p className="text-xl text-white/80 max-w-2xl mx-auto mb-8">
            SQUIDEMY is preparing to launch the ultimate IT training platform. 
            We're putting the finishing touches on courses, labs, and tools to help you 
            master IT skills and advance your career.
          </p>

          {/* Countdown/Status */}
          {hasLaunchDate ? (
            <div className="space-y-4">
              <div className="flex items-center justify-center gap-2 text-white/80">
                <Calendar className="w-5 h-5" />
                <span className="text-sm">Launching {new Date(launchDate).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
              </div>
              <div className="flex flex-wrap justify-center gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 min-w-[100px] border border-white/20">
                  <div className="text-4xl font-bold text-white">{countdown.days}</div>
                  <div className="text-sm text-white/60">Days</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 min-w-[100px] border border-white/20">
                  <div className="text-4xl font-bold text-white">{countdown.hours}</div>
                  <div className="text-sm text-white/60">Hours</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 min-w-[100px] border border-white/20">
                  <div className="text-4xl font-bold text-white">{countdown.minutes}</div>
                  <div className="text-sm text-white/60">Minutes</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 min-w-[100px] border border-white/20">
                  <div className="text-4xl font-bold text-white">{countdown.seconds}</div>
                  <div className="text-sm text-white/60">Seconds</div>
                </div>
              </div>
            </div>
          ) : (
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
              <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse" />
              <span className="text-white/90 font-medium">Launching Soon</span>
            </div>
          )}
        </div>

        {/* Features Preview */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition-all hover:scale-105">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mb-4">
              <GraduationCap className="w-7 h-7 text-white" />
            </div>
            <h3 className="text-lg font-bold mb-2">Expert-Led Courses</h3>
            <p className="text-white/60 text-sm">
              Learn from industry professionals with real-world experience in IT and cybersecurity.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition-all hover:scale-105">
            <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center mb-4">
              <Monitor className="w-7 h-7 text-white" />
            </div>
            <h3 className="text-lg font-bold mb-2">Hands-On Labs</h3>
            <p className="text-white/60 text-sm">
              Practice in real virtual environments with our interactive lab simulations.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition-all hover:scale-105">
            <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-4">
              <Award className="w-7 h-7 text-white" />
            </div>
            <h3 className="text-lg font-bold mb-2">Certification Prep</h3>
            <p className="text-white/60 text-sm">
              Get ready for CompTIA, AWS, Azure, and other top industry certifications.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition-all hover:scale-105">
            <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center mb-4">
              <Users className="w-7 h-7 text-white" />
            </div>
            <h3 className="text-lg font-bold mb-2">Community Support</h3>
            <p className="text-white/60 text-sm">
              Join our Discord community and connect with fellow IT learners.
            </p>
          </div>
        </div>

        {/* What We're Building Section */}
        <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10 mb-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">What We're Building</h2>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold mb-1">Active Directory Training</h3>
                    <p className="text-white/60 text-sm">Master Windows Server, AD DS, Group Policy, and enterprise administration.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold mb-1">Cybersecurity Fundamentals</h3>
                    <p className="text-white/60 text-sm">Learn security principles, threat detection, and defense strategies.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold mb-1">Cloud Computing</h3>
                    <p className="text-white/60 text-sm">Get hands-on with AWS, Azure, and Google Cloud platforms.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold mb-1">Homelab Setup Guides</h3>
                    <p className="text-white/60 text-sm">Build your own learning environment with step-by-step tutorials.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="relative">
                <img 
                  src="/squiddy_logo.png" 
                  alt="Squidemy Mascot" 
                  className="w-64 h-64 object-contain drop-shadow-2xl"
                />
                <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-purple-600 to-orange-500 px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                  Coming Soon!
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="max-w-2xl mx-auto text-center mb-12">
          <div className="bg-gradient-to-r from-purple-600/80 to-orange-500/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/20">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center">
                <Bell className="w-8 h-8 text-white" />
              </div>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mb-4">Be the First to Know</h2>
            <p className="text-white/90 mb-6">
              Sign up for our newsletter and get notified when we launch. 
              Plus, receive exclusive early-bird discounts and free resources!
            </p>

            {subscribed ? (
              <div className="bg-white/20 rounded-xl p-6">
                <CheckCircle className="w-12 h-12 text-green-400 mx-auto mb-3" />
                <p className="text-lg font-semibold">You're on the list!</p>
                <p className="text-white/80 text-sm">We'll send you updates as we get closer to launch.</p>
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                <Input 
                  type="email" 
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-white/20 border-white/30 text-white placeholder:text-white/60 flex-1"
                  required
                />
                <Button 
                  type="submit"
                  className="bg-white text-purple-600 hover:bg-white/90 font-semibold"
                  disabled={isSubscribing}
                >
                  {isSubscribing ? (
                    <Loader2 className="w-4 h-4 animate-spin mr-2" />
                  ) : null}
                  {isSubscribing ? 'Subscribing...' : 'Notify Me'}
                  {!isSubscribing && <ArrowRight className="ml-2 h-4 w-4" />}
                </Button>
              </form>
            )}
          </div>
        </div>

        {/* Merch Section */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-gradient-to-r from-orange-500/20 to-pink-500/20 backdrop-blur-sm rounded-3xl p-8 md:p-10 border border-orange-500/30 hover:border-orange-500/50 transition-all">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <div className="w-32 h-32 bg-gradient-to-br from-orange-500 to-pink-500 rounded-2xl flex items-center justify-center shadow-2xl shadow-orange-500/30">
                  <ShoppingBag className="w-16 h-16 text-white" />
                </div>
              </div>
              <div className="flex-1 text-center md:text-left">
                <h2 className="text-2xl md:text-3xl font-bold mb-3">
                  🎁 Get Your SQUIDEMY Merch!
                </h2>
                <p className="text-white/80 mb-4">
                  Support Squidemy and look amazing doing it! Check out our exclusive collection of t-shirts, hoodies, stickers, and more. 
                  Rep the brand and show you're part of the IT learning revolution!
                </p>
                <div className="flex flex-wrap justify-center md:justify-start gap-3">
                  <a 
                    href="https://squidemy.fourthwall.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <Button className="bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white font-semibold px-6">
                      <ShoppingBag className="w-5 h-5 mr-2" />
                      Shop Merch Now
                      <ExternalLink className="w-4 h-4 ml-2" />
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Share This Page Section */}
        <div className="max-w-2xl mx-auto mb-12">
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 text-center">
            <h3 className="text-xl font-bold mb-3 flex items-center justify-center gap-2">
              <Share2 className="w-5 h-5 text-cyan-400" />
              Share SQUIDEMY with Friends
            </h3>
            <p className="text-white/60 mb-4 text-sm">
              Know someone who wants to level up their IT skills? Spread the word!
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              <Button
                onClick={() => handleShare('twitter')}
                className="bg-black hover:bg-gray-800 text-white"
              >
                <svg className="w-4 h-4 mr-2" fill="white" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
                Tweet
              </Button>
              <Button
                onClick={() => handleShare('facebook')}
                className="bg-[#1877F2] hover:bg-[#166FE5] text-white"
              >
                <svg className="w-4 h-4 mr-2" fill="white" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                Share
              </Button>
              <Button
                onClick={() => handleShare('linkedin')}
                className="bg-[#0A66C2] hover:bg-[#0958A8] text-white"
              >
                <svg className="w-4 h-4 mr-2" fill="white" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                Post
              </Button>
              <Button
                onClick={() => handleShare('whatsapp')}
                className="bg-[#25D366] hover:bg-[#20BD5A] text-white"
              >
                <svg className="w-4 h-4 mr-2" fill="white" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                WhatsApp
              </Button>
              <Button
                onClick={handleCopyLink}
                variant="outline"
                className="border-white/30 text-white hover:bg-white/10"
              >
                <Copy className="w-4 h-4 mr-2" />
                Copy Link
              </Button>
            </div>
          </div>
        </div>

        {/* Join Our Community - All Social Links */}
        <div className="text-center mb-12">
          <h3 className="text-2xl font-bold mb-4">Follow Us & Stay Connected</h3>
          <p className="text-white/60 mb-6">Join our community on social media and be part of the IT learning revolution!</p>
          
          <SocialLinksFull />
        </div>

        {/* Footer - Clean & Minimal */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col items-center gap-4">
            {/* Merch Link in Footer */}
            <a 
              href="https://squidemy.fourthwall.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white/60 hover:text-orange-400 transition-colors"
            >
              <ShoppingBag className="w-4 h-4" />
              <span className="text-sm">Shop SQUIDEMY Merch</span>
              <ExternalLink className="w-3 h-3" />
            </a>
            
            <p className="text-white/40 text-sm text-center">
              © {new Date().getFullYear()} Squidemy. All rights reserved. | Empowering IT careers through accessible, quality education.
            </p>
          </div>
        </div>
      </div>

      {/* Sequence Code Dialog */}
      <Dialog open={showSequenceDialog} onOpenChange={setShowSequenceDialog}>
        <DialogContent className="bg-slate-900 border-slate-700 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-xl">
              <KeyRound className="w-6 h-6 text-purple-400" />
              Admin Access
            </DialogTitle>
            <DialogDescription className="text-slate-400">
              Enter the sequence code to access the admin area during maintenance.
            </DialogDescription>
          </DialogHeader>
          
          <form onSubmit={handleVerifySequenceCode} className="space-y-4 mt-4">
            <div>
              <Input
                type="text"
                placeholder="Enter sequence code..."
                value={sequenceCode}
                onChange={(e) => {
                  setSequenceCode(e.target.value);
                  setCodeError('');
                }}
                className="bg-slate-800 border-slate-600 text-white text-center text-sm font-mono"
                autoComplete="off"
              />
              {codeError && (
                <p className="text-red-400 text-sm mt-2 flex items-center gap-1">
                  <X className="w-4 h-4" />
                  {codeError}
                </p>
              )}
            </div>
            
            <div className="flex gap-3">
              <Button
                type="button"
                variant="outline"
                onClick={() => setShowSequenceDialog(false)}
                className="flex-1 border-slate-600 text-slate-300 hover:bg-slate-800"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={isVerifying || !sequenceCode.trim()}
                className="flex-1 bg-purple-600 hover:bg-purple-700"
              >
                {isVerifying ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin mr-2" />
                    Verifying...
                  </>
                ) : (
                  <>
                    <KeyRound className="w-4 h-4 mr-2" />
                    Unlock
                  </>
                )}
              </Button>
            </div>
          </form>
          
          <p className="text-xs text-slate-500 text-center mt-4">
            Contact your administrator if you don't have a sequence code.
          </p>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MaintenancePage;
